export const ANONYMOUS_LAYOUT_ROUTE_CONFIG = {
  skipAuth: true,
};
